(function () {
  'use strict';
  var w = window, d = document, root = d.documentElement, body = d.body;
  if (!body) return;
  root.classList.add('bb-js');

  var reduce = !!(w.matchMedia && w.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var designMode = !!(w.Shopify && w.Shopify.designMode);
  var mobile = w.matchMedia ? w.matchMedia('(max-width: 989px)') : { matches: false };

  function findHeader() {
    var sels = ['.shopify-section-group-header-group', '.shopify-section-group-main-header-group', 'header[role="banner"]', 'header'];
    for (var i = 0; i < sels.length; i++) {
      var el = d.querySelector(sels[i]);
      if (el) return el;
    }
    return null;
  }
  function findAnnouncement(header) {
    var sels = ['[id*="announcement-bar"]', '[class*="announcement-bar"]'];
    for (var i = 0; i < sels.length; i++) {
      var el = d.querySelector(sels[i]);
      if (el && (!header || !header.contains(el))) return el;
    }
    return null;
  }

  var header = findHeader();
  var ann = findAnnouncement(header);
  var main = d.getElementById('MainContent');
  var hero = (body.classList.contains('bb-tpl-index') && main) ? main.querySelector(':scope > .shopify-section') : null;

  if (header) {
    header.classList.add('bb-header');
    var logo = header.querySelector('a img, img');
    if (logo) logo.classList.add('bb-header-logo');
  }

  var bar = d.createElement('div');
  bar.className = 'bb-progress';
  bar.setAttribute('aria-hidden', 'true');
  body.appendChild(bar);

  var lastY = w.pageYOffset || 0, ticking = false;

  function frame() {
    ticking = false;
    var y = w.pageYOffset || root.scrollTop || 0;
    var vh = w.innerHeight || root.clientHeight;
    body.classList.toggle('bb-scrolled', y > 24);

    if (header) {
      var top = 0;
      if (ann) {
        var r = ann.getBoundingClientRect();
        if (r.height && r.top <= 0.5 && r.bottom > 0) top = Math.round(r.bottom);
      }
      header.style.setProperty('--bb-top', top + 'px');
      if (mobile.matches && !reduce && !designMode) {
        if (y > lastY + 6 && y > 320) body.classList.add('bb-hide-header');
        else if (y < lastY - 6 || y <= 320) body.classList.remove('bb-hide-header');
      } else {
        body.classList.remove('bb-hide-header');
      }
    }

    var max = root.scrollHeight - vh;
    bar.style.transform = 'scaleX(' + (max > 0 ? Math.min(1, Math.max(0, y / max)) : 0).toFixed(4) + ')';

    if (hero && !reduce) {
      var h = hero.offsetHeight || 1;
      if (y <= h * 1.5) hero.style.setProperty('--bb-hero-shift', (Math.min(1, y / h) * 4.5).toFixed(2) + '%');
    }
    lastY = y;
  }

  function request() {
    if (!ticking) { ticking = true; w.requestAnimationFrame(frame); }
  }
  w.addEventListener('scroll', request, { passive: true });
  w.addEventListener('resize', request, { passive: true });
  frame();

  if (reduce || designMode || !main || !('IntersectionObserver' in w)) return;

  function pickItems(section) {
    var list = section.querySelectorAll('li, [class*="grid"] > *');
    var out = [];
    for (var i = 0; i < list.length && out.length < 16; i++) {
      var el = list[i];
      if (!el.querySelector('img')) continue;
      var skip = false;
      for (var j = 0; j < out.length; j++) {
        if (out[j].contains(el) || el.contains(out[j])) { skip = true; break; }
      }
      if (!skip) out.push(el);
    }
    return out.length > 1 ? out : [];
  }

  function finish(section) {
    section.classList.remove('bb-reveal', 'bb-in');
    var items = section.querySelectorAll('.bb-item');
    for (var i = 0; i < items.length; i++) {
      items[i].classList.remove('bb-item');
      items[i].style.removeProperty('--bb-i');
    }
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var s = entry.target;
      io.unobserve(s);
      s.classList.add('bb-in');
      setTimeout(function () { finish(s); }, 2400);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });

  var vh0 = w.innerHeight || root.clientHeight;
  var sections = main.querySelectorAll(':scope > .shopify-section');
  for (var k = 1; k < sections.length; k++) {
    var s = sections[k];
    if (s.offsetHeight < 8) continue;
    if (s.getBoundingClientRect().top < vh0 * 0.9) continue;
    s.classList.add('bb-reveal');
    var items = pickItems(s);
    for (var m = 0; m < items.length; m++) {
      items[m].classList.add('bb-item');
      items[m].style.setProperty('--bb-i', String(m % 8));
    }
    io.observe(s);
  }
})();
